import type { StorefrontAdapter } from '../types';
import { loadScriptOnce } from '../types';

declare global {
  interface Window {
    yotpo?: { refreshWidgets?: () => void; initWidgets?: () => void };
    yotpoWidgetsContainer?: { initWidgets?: () => void };
    yotpoTrackConversionData?: { orderId: string; orderAmount: string; orderCurrency: string };
  }
}

/**
 * Yotpo Reviews: the v3 widget loader renders any `.yotpo-widget-instance` /
 * `.yotpo` elements on the page. SPA navigation needs an explicit re-init.
 * Conversion tracking on the thank-you page uses Yotpo's documented global.
 */
export const yotpoAdapter: StorefrontAdapter = {
  id: 'yotpo',
  isConfigured: (cfg) => typeof cfg.app_key === 'string' && /^[A-Za-z0-9_-]{8,64}$/.test(cfg.app_key),
  load(cfg) {
    loadScriptOnce('yotpo-loader', `https://cdn-widgetsrepository.yotpo.com/v1/loader/${encodeURIComponent(cfg.app_key)}`);
  },
  refresh() {
    window.yotpoWidgetsContainer?.initWidgets?.();
    window.yotpo?.refreshWidgets?.();
  },
  orderCompleted(order) {
    window.yotpoTrackConversionData = {
      orderId: String(order.order_number ?? order.id),
      orderAmount: String(order.total.toFixed(2)),
      orderCurrency: order.currency ?? 'USD',
    };
    // Legacy pixel still accepted alongside the v3 loader; harmless if ignored.
    const key = (document.getElementById('yotpo-loader') as HTMLScriptElement | null)?.src.split('/loader/')[1];
    if (!key) return;
    const img = document.createElement('img');
    img.alt = '';
    img.width = 1;
    img.height = 1;
    img.style.display = 'none';
    img.src = `https://api.yotpo.com/conversion_tracking.gif?app_key=${encodeURIComponent(key)}&order_id=${encodeURIComponent(String(order.order_number ?? order.id))}&order_amount=${encodeURIComponent(order.total.toFixed(2))}&order_currency=${encodeURIComponent(order.currency ?? 'USD')}`;
    document.body.appendChild(img);
  },
};
